import SessionLimitIcon from '@assets/media/session-limit-icon.png';
import { translationPacket } from 'common/actions';
import { FullscreenError } from 'common/components/full-screen-error';
import { H1 } from 'common/components/Typography';
import { getScalablePixel } from 'common/utils';
import { isEmpty } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

export const Title = styled(H1)`
  font-size: ${getScalablePixel(48)}px;
`;

interface RestrictedAccessProps {
  i18n: typeof translationPacket;
}
function RestrictedAccess({ i18n }: RestrictedAccessProps) {
  if (isEmpty(i18n)) {
    return null;
  }

  return (
    <FullscreenError
      title={<Title>{i18n.authentication.tooManyUsers}</Title>}
      description={i18n.authentication.tooManyUsersDescription}
      info={i18n.authentication.tooManyUsersInfo}
      icon={SessionLimitIcon}
    />
  );
}

const mapStateToProps = ({ i18n }: any) => ({
  i18n
});

export default React.memo(connect(mapStateToProps, {})(RestrictedAccess));
